import { useNavigate, useParams } from 'react-router-dom';
import CustomHistory from '../components/customHistory/CustomHistorySection';
import Footer from '../components/Footer/FooterSection';
import HeaderTwo from '../components/HeaderTwo/HeaderTwoSection';
import '../styles/trackingdetails.scss';
import { useNotification } from '../context/NotificationContext';
import { useEffect, useState } from 'react';
import { getOrder } from '../api/requests';
import SkeletonLoader from '../components/SkeletonLoaders/DefaultLoader';
import { OrderShow, OrderTimeline } from '../interface/interfaces';
import 'animate.css';

const TrackingDetails = () => {
 const navigate = useNavigate();
 const { orderid, trackingid } = useParams();
 const { notify } = useNotification();

 type pageProp = {
  orderData: OrderShow | null;
  isLoading: boolean;
  max: number;
 };

 const [pageData, setPageData] = useState<pageProp>({
  orderData: null,
  isLoading: false,
  max: 7,
 });

 const [currentTimeline, setCurrentTimeline] = useState<
  OrderTimeline[]
 >([]);

 // {
 //       'created': 'Order has been created',
 //       'ready': 'Order is ready for processing',
 //       'delivered': 'Order has been delivered',
 //       'awaiting vendor confirmation': 'Waiting for vendor to confirm',
 //       'awaitingconfirmation': 'Waiting for vendor to confirm',
 //       'pending pick-up': 'Order is waiting to be picked up',
 //       'pendingpickup': 'Order is waiting to be picked up',
 //       'picked up': 'Order has been picked up',
 //       'picked_up': 'Order has been picked up',
 //       'dispatched': 'Order is on its way',
 //       'returned': 'Order was returned',
 //       'cancelled': 'Order has been cancelled',
 //   };

 // const [progressTimeline,setProgressTimeline]=useState([
 //   {name:'created',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 //   {name:'awaiting vendor confirmation',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 //   {name:'ready',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 //   {name:'assigned to a rider',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 //   {name:'picked-up',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 //   {name:'dispatched',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 //   {name:'delivered',isTimelineTrue:false,isInterrupted:false,interruptionType:null},
 // ])

 const setPageLoader = (value: boolean) => {
  setPageData((prev) => {
   return {
    ...prev,
    isLoading: value,
   };
  });
 };

 const isTimelineComplete = (events: OrderTimeline[]): boolean => {
  return events.some(
   (event) => event.status.toLowerCase() === 'delivered',
  );
 };

 useEffect(() => {
  const func = async () => {
   if (!orderid) {
    notify.error('Invalid link, please reload!');
    return;
   }

   try {
    setPageLoader(true);
    let result = await getOrder(orderid);
    console.log('result', result);
    if (result) {
     setPageData((prev) => {
      return {
       ...prev,
       orderData: result,
      };
     });

     if (trackingid) {
      let obj = result.products.find((data) => {
       return data.id === trackingid;
      });

      if (obj) {
       let timeline = obj.order_timeline;
       setCurrentTimeline(timeline);
      }
     } else {
      let obj = result.products[0];

      if (obj) {
       let timeline = obj.order_timeline;
       setCurrentTimeline(timeline);
      }
     }
    } else {
     notify.error('Order not found!');
    }
   } catch (error: any) {
    notify.error(error.message);
   } finally {
    setPageLoader(false);
   }
  };

  func();
  // eslint-disable-next-line
 }, []);

 // const dateFunc = (rawDate: string): string => {
 //   const date = new Date(rawDate);

 //   const opts: Intl.DateTimeFormatOptions = {
 //     year: 'numeric',
 //     month: 'long',
 //     day: 'numeric',
 //   };

 //   const formatted = date.toLocaleDateString('en-US', opts);
 //   return formatted;
 // };

 // const colorFunc = (
 //   text: string
 // ): 'green' | 'yellow' | 'red' | 'default' => {
 //   const normalized = text.trim().toLowerCase();

 //   const colorMap: Record<'green' | 'yellow' | 'red', string[]> = {
 //     green: ['created', 'ready', 'delivered', 'picked_up', 'picked up', 'dispatched','assigned to a rider'],
 //     yellow: [
 //       'awaiting vendor confirmation', 'awaitingconfirmation',
 //       'pending pick-up', 'pendingpickup',
 //       'returned',
 //     ],
 //     red: ['cancelled'],
 //   };

 //   for (const [color, keywords] of Object.entries(colorMap) as [keyof typeof colorMap, string[]][]) {
 //     if (keywords.some(k => normalized === k)) {
 //       return color;
 //     }
 //   }

 //   return 'default';
 // };

 // const statusMessage = (text: string): string => {
 //   const phrase = text.trim().toLowerCase();

 //   const messages: Record<string, string> = {
 //     'created': 'Order has been created',
 //     'ready': 'Order is ready for processing',
 //     'delivered': 'Order has been delivered',
 //     'awaiting vendor confirmation': 'Waiting for vendor to confirm',
 //     'awaitingconfirmation': 'Waiting for vendor to confirm',
 //     'pending pick-up': 'Order is waiting to be picked up',
 //     'pendingpickup': 'Order is waiting to be picked up',
 //     'picked up': 'Order has been picked up',
 //     'picked_up': 'Order has been picked up',
 //     'dispatched': 'Order is on its way',
 //     'returned': 'Order was returned',
 //     'cancelled': 'Order has been cancelled',
 //   };

 //   return messages[phrase] || 'Status update not available';
 // };

 return (
  <>
   <HeaderTwo></HeaderTwo>

   <CustomHistory></CustomHistory>

   <div className="content trackingdetails">
    {pageData.isLoading && (
     <SkeletonLoader count={4}></SkeletonLoader>
    )}

    {!pageData.isLoading && pageData.orderData && (
     <div className="animate__animated animate__fadeIn animate__fast">
      <div className="pagetitle">
       <div
        className="icon goback"
        onClick={() => navigate(-1)}
       ></div>
       <div>
        Order <span style={{ fontWeight: '600' }}>{orderid}</span>
       </div>
      </div>

      <div className="trackprogress">
       <div
        className="progressbox"
        style={{
         gridTemplateColumns: `${
          currentTimeline.length > pageData.max
           ? 'repeat(' + currentTimeline.length + ',1fr)'
           : 'repeat(' + pageData.max + ',1fr)'
         }`,
        }}
       >
        {currentTimeline.map((data, idx) => (
         <div
          className="zma filled"
          key={idx}
         >
          <div className="eachprog">{idx + 1}</div>
         </div>
        ))}

        {!isTimelineComplete(currentTimeline) && (
         <>
          {currentTimeline.length < pageData.max && (
           <>
            {[...Array(pageData.max - currentTimeline.length)].map(
             (_, i) => (
              <div
               className="zma notfilled"
               key={i}
              >
               <div className="eachprog">
                {i + 1 + currentTimeline.length}
               </div>
              </div>
             ),
            )}
           </>
          )}
         </>
        )}
       </div>

       <div
        className="textbox"
        style={{
         gridTemplateColumns: `${
          currentTimeline.length > pageData.max
           ? 'repeat(' + currentTimeline.length + ',1fr)'
           : 'repeat(' + pageData.max + ',1fr)'
         }`,
        }}
       >
        {currentTimeline.map((data, idx) => (
         <div
          className="progtext"
          key={idx}
         >
          {data.status}
         </div>
        ))}

        {!isTimelineComplete(currentTimeline) && (
         <>
          {currentTimeline.length < pageData.max && (
           <>
            {[...Array(pageData.max - currentTimeline.length)].map(
             (_, i) => (
              <div className="progtext empty">.</div>
             ),
            )}
           </>
          )}
         </>
        )}

        {/* 
              <div className="progtext">Shipped</div>
              <div className="progtext">Out for delivery</div>
              <div className="progtext">Delivered</div> */}
       </div>
      </div>

      <div className="notetab">
       <div className="notetitle">Please note:</div>

       <div className="notelist">
        <div className="eachlist">
         <div className="listdot"></div>
         <div className="listtext">
          If you ordered multiple items, you may receive the items on
          different days
         </div>
        </div>

        <div className="eachlist">
         <div className="listdot"></div>
         <div className="listtext">
          Also, note that you can no longer cancel your order because
          it has already been placed
         </div>
        </div>
       </div>

       <div className="morenote">
        If you have any questions regarding your package visit
        Yayako.com
       </div>
      </div>
     </div>
    )}
   </div>

   <Footer></Footer>
  </>
 );
};

export default TrackingDetails;
